/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unsupported_File_TypeInputs */

const en_common_unsupported_file_type = /** @type {(inputs: Common_Unsupported_File_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a supported file type`)
};

const es_common_unsupported_file_type = /** @type {(inputs: Common_Unsupported_File_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo no compatible`)
};

/**
* | output |
* | --- |
* | "Not a supported file type" |
*
* @param {Common_Unsupported_File_TypeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_unsupported_file_type = /** @type {((inputs?: Common_Unsupported_File_TypeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unsupported_File_TypeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_unsupported_file_type(inputs)
	return en_common_unsupported_file_type(inputs)
});